import { ThunkDispatch } from "core-integration/src/store";
import { getMostValuableTeams } from "core-integration/src/store/stats/reducers";
import { fetchMostValuableTeams } from "core-integration/src/store/stats/thunks";
import Link from "plos/src/components/links/Link";
import { Cell, Column, Table } from "plos/src/components/Table";
import { integerToMoneyWithCurrency } from "plos/src/utils/money";
import { useEffect } from "react";
import { Row, TableBody, TableHeader } from "react-aria-components";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { StatusPanel } from "../../StatusPanel";
import {
  leagueTeamHeader,
  leagueTeamName,
  leagueTeamPosition,
  leagueTeamTable,
  leagueTeamTableRow,
  nameCell,
  nameCol,
  posCell,
  posCol,
  scoreCell,
  scoreCol,
} from "../leaguesAndTeams.css";

const ValuableTeams = () => {
  const dispatch = useDispatch<ThunkDispatch>();
  const teams = useSelector(getMostValuableTeams);

  const { t } = useTranslation("status");

  useEffect(() => {
    dispatch(fetchMostValuableTeams());
  }, [dispatch]);

  return (
    <StatusPanel title={t("mostValuableTeams", "Most Valuable Teams")}>
      <Table
        className={leagueTeamTable}
        aria-label={t("mostValuableTeams", "Most Valuable Teams")!}
      >
        <TableHeader className={leagueTeamHeader}>
          <Column isRowHeader className={posCol}>
            {t("positionAbbr", "Pos")}
          </Column>
          <Column className={nameCol}>{t("team", "Team")}</Column>
          <Column className={scoreCol}>{t("value", "Value")}</Column>
        </TableHeader>
        <TableBody>
          {teams.slice(0, 5).map((t, i) => (
            <Row className={leagueTeamTableRow} key={t.entry}>
              <Cell className={posCell}>
                <span className={leagueTeamPosition}>{i + 1}</span>
              </Cell>
              <Cell className={nameCell}>
                <Link to={`/entry/${t.entry}/history`}>
                  <span className={leagueTeamName}>{t.name}</span>
                </Link>
              </Cell>
              <Cell className={scoreCell}>
                {integerToMoneyWithCurrency(t.value_with_bank, 10)}
              </Cell>
            </Row>
          ))}
        </TableBody>
      </Table>
      {!teams.length &&
        t(
          "mostValuableTeamsAvailability",
          "The Most Valuable Teams will appear here when available.",
        )}
    </StatusPanel>
  );
};

export default ValuableTeams;
